var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 23.4219C6.36751 23.4219 1.6665 18.7209 1.6665 12.9219C1.6665 7.12289 6.36751 2.42188 12.1665 2.42188C17.9655 2.42188 22.6665 7.12289 22.6665 12.9219C22.6665 18.7209 17.9655 23.4219 12.1665 23.4219ZM12.1665 24.9219C18.7939 24.9219 24.1665 19.5493 24.1665 12.9219C24.1665 6.29446 18.7939 0.921875 12.1665 0.921875C5.53909 0.921875 0.166504 6.29446 0.166504 12.9219C0.166504 19.5493 5.53909 24.9219 12.1665 24.9219Z",
    fill: "#5E6470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04917 9.6011C8.03778 9.80542 8.20636 9.97095 8.41101 9.97095H9.64774C9.85484 9.97095 10.0195 9.80207 10.0473 9.59684C10.1808 8.61265 10.8563 7.89526 12.0603 7.89526C13.0887 7.89526 14.0313 8.40942 14.0313 9.64722C14.0313 10.5994 13.4695 11.0374 12.584 11.7039C11.5747 12.437 10.7749 13.2939 10.8321 14.6841L10.8365 15.0093C10.8393 15.2144 11.0064 15.3792 11.2115 15.3792H12.428C12.6351 15.3792 12.803 15.2113 12.803 15.0042V14.8459C12.803 13.77 13.2124 13.4558 14.3169 12.6179C15.231 11.9229 16.1831 11.1516 16.1831 9.53296C16.1831 7.26685 14.2693 6.17188 12.1746 6.17188C10.274 6.17188 8.19096 7.05779 8.04917 9.6011ZM10.3846 18.2451C10.3846 19.0449 11.0225 19.6353 11.8985 19.6353C12.8125 19.6353 13.4409 19.0449 13.4409 18.2451C13.4409 17.4167 12.8125 16.8359 11.8985 16.8359C11.0225 16.8359 10.3846 17.4167 10.3846 18.2451Z",
    fill: "#5E6470"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.5de84afdafe3641a7f8bf3d4e267fce3.svg";
export { ForwardRef as ReactComponent };